export default "__VITE_ASSET__BxHjTl2v__"